import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';
import {AlertCountDisplayComponent} from '../../shared/alert-count-display/alert-count-display.component';

@Component({
  selector: 'mobile-top-bar',
  standalone: true,
  imports: [NgClass, AlertCountDisplayComponent],
  templateUrl: './mobile-top-bar.component.html',
  styleUrl: './mobile-top-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileTopBarComponent {
  @Input() menuOpen = false;
  @Output() toggleMenu = new EventEmitter<void>();

  toggleMenuState(): void {
    this.toggleMenu.emit();
  }
}
